enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error'
}

export default ToastType;
